module.exports = __webpack_public_path__ + "img/9b6ef6d.svg";